export default __webpack_public_path__ + "static/solist-demisolists-32a1fe5e47b18f4a391b71c9bda113d2.jpg";